import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class ClockGenerationAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normFo = 40;
		this.normFi = 10;
		this.normVcc = 2.7;

		this.rankFo = 0;
		this.rankFi = 0;
		this.rankVcc = 0;

		this.weightFo = 0.17;
		this.weightFi = 0.17;
		this.weightVcc = 0.16;

		this.rFo = 0;
		this.rFi = 0;
		this.rVcc = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_Fo,rFo,rankFo,part_Fi,rFi,rankFi,part_Vcc,rVcc,rankVcc,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Output frequency  fout Typ (MHz)---------------------------------------------

		[this.rankFo, this.rFo] = this.calculateRankSingleSliderGTE(CIDS.F_OUT_TYP, product, this.normFo);

		// ---------------------------------------------Input frequency  fin Typ (MHz)---------------------------------------------

		[this.rankFi, this.rFi] = this.calculateRankSingleSliderGTE(CIDS.F_IN_TYP, product, this.normFi);

		// ---------------------------------------------Supply voltage  VCC Typ (V)---------------------------------------------

		[this.rankVcc, this.rVcc] = this.calculateRankSingleSliderGTE(CIDS.V_CC_TYP, product, this.normVcc);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightFo * this.rankFo + this.weightFi * this.rankFi + this.weightVcc * this.rankVcc;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightFo - this.weightFi - this.weightVcc) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
